import {z} from "zod"

export const FixedValueDefinition = <ValueType>(ValueSchema: z.ZodSchema<ValueType>) => ({
    validation: {
        returns: ValueSchema,
        parameters: z.object({value: ValueSchema}),
    },
})
